import { requisitarJson } from '../../../shared/api/http';

export interface Material {
    id: string;
    titulo: string;
    ordem: number;
    /** Enigma do Scan Pixel que libera o material; `null` é "sempre liberado". */
    enigma_ordem: number | null;
    arquivo_nome: string | null;
    arquivo_bytes: number | null;
    arquivo_enviado_em: string | null;
}

export type AlteracaoMaterial = Partial<Pick<Material, 'titulo' | 'enigma_ordem' | 'ordem'>>;

const BASE = '/api/v1/materiais';
const JSON_TIPO = { 'Content-Type': 'application/json' };

export function listarMateriais(): Promise<Material[]> {
    return requisitarJson(BASE);
}

export function criarMaterial(dados: { titulo: string; enigma_ordem: number | null }, csrfToken: string): Promise<Material> {
    return requisitarJson(BASE, { method: 'POST', csrfToken, headers: JSON_TIPO, body: JSON.stringify(dados) });
}

export function alterarMaterial(id: string, mudanca: AlteracaoMaterial, csrfToken: string): Promise<Material> {
    return requisitarJson(`${BASE}/${encodeURIComponent(id)}`, {
        method: 'PATCH', csrfToken, headers: JSON_TIPO, body: JSON.stringify(mudanca),
    });
}

/** O corpo é o próprio PDF. O nome vai codificado: cabeçalho HTTP não leva acento. */
export function enviarArquivo(id: string, arquivo: File, csrfToken: string): Promise<Material> {
    return requisitarJson(`${BASE}/${encodeURIComponent(id)}/arquivo`, {
        method: 'PUT',
        csrfToken,
        headers: { 'Content-Type': 'application/pdf', 'X-Nome-Do-Arquivo': encodeURIComponent(arquivo.name) },
        body: arquivo,
    });
}

export function excluirMaterial(id: string, csrfToken: string): Promise<void> {
    return requisitarJson(`${BASE}/${encodeURIComponent(id)}`, { method: 'DELETE', csrfToken });
}
